import { Grid, Text } from '@mantine/core';
import {
  IconCheck,
  IconCircleArrowDown,
  IconCircleArrowUp,
  IconClock,
  IconQuestionMark,
  IconX,
} from '@tabler/icons-react';
import prettifiedLabel from '../../constants/labelPrettifier';

const AbTestSummaryElement = ({ result, isSuperAdmin }) => {
  const haveChange = result.change > 0;
  const haveSignificance = (result.significance * 100).toFixed(2) > 90;

  const getTestStatus = () => {
    if (!haveSignificance) {
      return (
        <span>
          <IconClock size={14} style={{ color: 'var(--mantine-color-yellow-6)' }} /> Not yet significant{' '}
        </span>
      );
    }

    if (haveSignificance && haveChange) {
      return (
        <span>
          <IconCheck size={14} style={{ color: 'var(--mantine-color-green-6)' }} /> Releva wins{' '}
        </span>
      );
    }

    if (haveSignificance && !haveChange) {
      return (
        <span>
          <IconX size={14} style={{ color: 'var(--mantine-color-red-6)' }} /> Releva doesn't win{' '}
        </span>
      );
    }

    return (
      <span>
        <IconQuestionMark size={14} /> Unknown{' '}
      </span>
    );
  };

  const getTestChange = () => {
    if (!isSuperAdmin) {
      return <Text c="dimmed">Test needs more data to reach significance</Text>;
    }

    const changeIndicator = haveChange ? (
      <IconCircleArrowUp size={14} style={{ color: 'var(--mantine-color-success-5)' }} />
    ) : (
      <IconCircleArrowDown size={14} style={{ color: 'var(--mantine-color-danger-5)' }} />
    );

    const changeMessage = haveChange ? (
      <Text component="span">
        &nbsp;Releva brings{' '}
        <Text component="b" fw={700}>
          MORE
        </Text>{' '}
        value to your shop.
      </Text>
    ) : (
      <Text component="span">
        &nbsp;Releva does{' '}
        <Text component="b" fw={700}>
          NOT BRING
        </Text>{' '}
        value at this moment.
      </Text>
    );

    return (
      <Text component="span">
        <Text component="strong" fw={700}>
          {result.change?.toFixed(2) || 'N/A'} % {changeIndicator}
        </Text>
        <Text component="span" c="dimmed">
          {changeMessage}
        </Text>
      </Text>
    );
  };

  return (
    <Grid>
      <Grid.Col span="auto">
        <Text>
          <Text component="span" fw={700}>
            {prettifiedLabel(result.name)}
          </Text>
        </Text>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 2 }}>{getTestStatus()}</Grid.Col>
      <Grid.Col span="auto">{getTestChange()}</Grid.Col>
      <Grid.Col span={{ base: 12, md: 2 }}>{(result.significance * 100).toFixed(2)} %</Grid.Col>
    </Grid>
  );
};

export default AbTestSummaryElement;
